import {
  Flexbox,
  Sizes,
  Text,
} from '@sede-enterprise/shell-ds-react-framework';

export const NoSiteFound = () => {
  return (
    <Flexbox flexDirection={'column'} style={{ padding: 12 }} gap="4px">
      <Text size={Sizes.Small} bold>
        No sites found...
      </Text>
      <Text size={Sizes.Small}>Try another search criteria</Text>
    </Flexbox>
  );
};
